import { createFileRoute } from "@tanstack/react-router"
import { PresentationLocationsReport } from "@/features/reports/components/PresentationLocationsReport"
import {
  applyPresentationLocationsDefaults,
  presentationLocationsQuery,
  PresentationLocationsSearchParams,
} from "@/features/reports/core/hooks/usePresentationLocationsReport"

export const Route = createFileRoute("/(authenticated)/reports/presentation-locations")({
  validateSearch: PresentationLocationsSearchParams,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps: search }) => {
    void context.queryClient.ensureQueryData(
      presentationLocationsQuery(applyPresentationLocationsDefaults(search)),
    )
  },
  component: PresentationLocationsReport,
})
